import { usePricingContext } from '@vp/react-pricing-context';
import { Box, ListPrice, Pricing, SkeletonText, SkeletonTextLine } from '@vp/swan';
import { VATMessage, priceFromFloat } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import type { Currency } from '@99designs/design-services-common';
import type { Price } from '../../types';

interface PriceProps {
    price?: Price;
    loading?: boolean;
}

export function HeaderPrice({ price, loading }: PriceProps) {
    if (!price && !loading) {
        return null;
    }

    return (
        <Box data-testid="price-container" aria-live="polite" aria-busy={loading}>
            <PriceContent loading={loading} price={price} />
        </Box>
    );
}

const PriceContent = ({ loading, price }: PriceProps) => {
    const pricingContext = usePricingContext();

    if (loading) {
        return (
            <SkeletonText data-testid="skeleton-text">
                <SkeletonTextLine width="narrow" margin={{ xs: 'auto', sm: 0 }}></SkeletonTextLine>
            </SkeletonText>
        );
    }

    if (!price) {
        return null;
    }

    const amount = pricingContext?.vatInclusive ? price.listPrice.taxed : price.listPrice.untaxed;

    return (
        <Pricing>
            <ListPrice>
                {__('Custom design from {{price}}', {
                    price: priceFromFloat({ amount, currency: price.currency as Currency }),
                    _context: 'Subtitle displaying the starting price for design services',
                })}
            </ListPrice>
            <VATMessage />
        </Pricing>
    );
};
